<ng-container>
  <form class="grey-box" [formGroup]="sessionForm">
    <div class="row">
      <div
        class="col-lg-4"
        *ngIf="allowedSessions.includes('Onsite') && isCertAdd == false"
      >
        <div
          style="cursor: pointer"
          [ngClass]="{ 'un-select': sessionType == 'Onsite' }"
          (click)="sessionForm.get('sessionType')?.setValue('Onsite')"
          class="selected-tag"
        >
          {{ "In attendance" | translator }}
        </div>
      </div>
      <div
        class="col-lg-4"
        *ngIf="allowedSessions.includes('Online') && isCertAdd == false"
      >
        <div
          style="cursor: pointer"
          [ngClass]="{
            'un-select': sessionForm.get('sessionType')?.value == 'Online'
          }"
          (click)="sessionForm.get('sessionType')?.setValue('Online')"
          class="selected-tag"
        >
          {{ "online" | translator }}
        </div>
      </div>
      <div
        class="col-lg-4"
        *ngIf="allowedSessions.includes('Video') && isCertAdd == false"
      >
        <div
          style="cursor: pointer"
          [ngClass]="{
            'un-select': sessionForm.get('sessionType')?.value == 'Video'
          }"
          (click)="sessionForm.get('sessionType')?.setValue('Video')"
          class="selected-tag"
        >
          {{ "Via videos" | translator }}
        </div>
      </div>
      <div
        class="col-lg-4"
        *ngIf="allowedSessions.includes('Certificate') && isCertAdd == true"
      >
        <div
          style="cursor: pointer"
          [ngClass]="{
            'un-select': sessionForm.get('sessionType')?.value == 'Certificate'
          }"
          class="selected-tag"
        >
          {{ "Certificate" | translator }}
        </div>
      </div>
    </div>
    <div *ngIf="!!sessionType">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-12 mb-3">
          <label class="label-ui" for="title"
            ><i class="fa-solid fa-book ml-2 mr-2 result-icons"></i
            >{{
              (sessionType == "Certificate"
                ? "certificate title"
                : "Session Title"
              ) | translator
            }}&nbsp;:&nbsp;</label
          >
          <input
            type="text"
            id="title"
            formControlName="title"
            pInputText
            class="w-100"
          />
          <div class="error" *ngIf="isFieldError('title')">
            <div>{{ "Session Title is required" | translator }}</div>
          </div>
        </div>

        <div
          *ngIf="sessionType != 'Video' && sessionType != 'Certificate'"
          class="col-lg-6 col-md-6 col-12 mb-3"
        >
          <label class="label-ui" for="date"
            ><i class="fa-solid fa-calendar-days ml-2 mr-2 result-icons"></i>
            {{ "the date" | translator }}&nbsp;:&nbsp;</label
          >
          <p-calendar
            class="v4-rtl-calander"
            appendTo="body"
            class="w-100"
            formControlName="date"
            dateFormat="dd-mm-yy"
            (onSelect)="dateValidate($event)"
            [readonlyInput]="false"
          >
            <ng-template pTemplate="date" let-date>
              <span
                [ngStyle]="{
                  textDecoration: disableDates(date)
                    ? 'line-through'
                    : 'inherit'
                }"
                >{{ date.day }}</span
              >
            </ng-template>
          </p-calendar>
          <div class="error" *ngIf="isFieldError('date')">
            <div>{{ "Date is Required" | translator }}</div>
          </div>
        </div>

        <div
          class="col-lg-6 col-md-6 col-12 mb-3"
          *ngIf="sessionType != 'Video' && sessionType != 'Certificate'"
        >
          <label class="label-ui" for="start_time"
            ><i class="fa-regular fa-clock ml-2 mr-2 result-icons"></i>
            {{ "Starting time" | translator }}&nbsp;:&nbsp;</label
          >
          <input
            type="time"
            id="start_time"
            formControlName="start_time"
            pInputText
            class="w-100"
          />
          <div class="error" *ngIf="isFieldError('start_time')">
            <div>{{ "start time is required" | translator }}</div>
          </div>
        </div>

        <div
          class="col-lg-6 col-md-6 col-12 mb-3"
          *ngIf="sessionType != 'Video' && sessionType != 'Certificate'"
        >
          <label class="label-ui" for="end_time"
            ><i class="fa-solid fa-stopwatch ml-2 mr-2 result-icons"></i>
            {{ "End Time" | translator }}&nbsp;:&nbsp;</label
          >
          <input
            type="time"
            id="end_time"
            formControlName="end_time"
            pInputText
            class="w-100"
          />
          <div class="error" *ngIf="isFieldError('end_time')">
            <div>{{ "end time is required" | translator }}</div>
          </div>
        </div>

        <div
          *ngIf="
            !UpdateTrainer &&
            sessionType != 'Video' &&
            sessionType != 'Certificate'
          "
          class="col-lg-12 col-md-12 col-12 mb-3"
        >
          <label class="label-ui" for="trainer"
            ><i class="fa fa-chalkboard-user ml-2 mr-2 result-icons"></i>
            {{ "the coach" | translator }}&nbsp;:&nbsp;</label
          >
          <div class="d-flex justify-content-between">
            <h5>{{ sessionFormData?.trainer?.name }}</h5>
            <button
              class="v4-btn-every py-2"
              (click)="changeUpdateTrainer(true)"
            >
              <i class="pi pi-edit v4-ml-2 v4-sstarabic">{{
                "update trainer" | translator
              }}</i>
            </button>
          </div>
        </div>

        <div
          *ngIf="
            UpdateTrainer &&
            sessionType != 'Video' &&
            sessionType != 'Certificate'
          "
          class="col-lg-6 col-md-6 col-12 mb-3"
        >
          <label class="label-ui" for="trainer"
            ><i class="fa fa-chalkboard-user 5555 ml-2 mr-2 result-icons"></i>
            {{
              (trainingType == "New Branch" ? "the coach" : "new branch coach")
                | translator
            }}&nbsp;:&nbsp;</label
          >
          <div
            class="{{
              sessionForm.get('trainer')?.hasError('customError') ||
              sessionForm.get('trainer')?.hasError('requestError')
                ? 'v4-error'
                : 'pp-drop'
            }}"
          >
            <p-dropdown
              styleClass="w-100"
              [options]="trainers"
              (onChange)="checkTrainerAvailability()"
              formControlName="trainer"
              optionLabel="name"
              appendTo="body"
              [filter]="true"
              filterBy="name"
              [showClear]="false"
              placeholder="{{ 'Choose the coach' | translator }}"
            >
              <ng-template let-trainers pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div>{{ trainers.name }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="error" *ngIf="isFieldError('trainer')">
            <div>{{ "Trainer required" | translator }}</div>
          </div>
          <div
            class="error"
            *ngIf="sessionForm.get('trainer')?.hasError('customError')"
          >
            <div>
              {{ "Trainer is not available at this time" | translator }}
            </div>
          </div>
          <div
            class="error"
            *ngIf="sessionForm.get('trainer')?.hasError('requestError')"
          >
            <div>
              {{
                "Please provide session date and time to assign trainer"
                  | translator
              }}
            </div>
          </div>
        </div>

        <div
          *ngIf="
            UpdateTrainer &&
            sessionType != 'Video' &&
            sessionType != 'Certificate'
          "
          class="col-lg-6 col-md-6 col-12 pt-4 mb-3"
        >
          <div class="row pt-3">
            <div
              *ngIf="isExternalTrainerAllowed() && !external"
              class="col-md-5 col-12"
            >
              <p-toggleButton
                class="v4-ptog-btn"
                styleClass="w-100"
                onLabel="{{ 'External' | translator }}"
                (onChange)="internalExternal($event)"
                offLabel="{{ 'Internal' | translator }}"
              ></p-toggleButton>
            </div>
            <div
              *ngIf="
                isExternalTrainerAllowed() && hasPermission('TRAINER', 'c')
              "
              class="col-md-5 col-12"
            >
              <button
                class="w-100 v4-btn-every py-2"
                (click)="addTrainerModal = true"
              >
                <i class="pi pi-plus v4-ml-2"></i
                >{{ "Add trainer" | translator }}
              </button>
            </div>
            <div class="col-md-2 col-12">
              <div class="">
                <i
                  pTooltip="{{ 'update trainer' | translator }}"
                  tooltipPosition="top"
                  *ngIf="!!sessionFormData"
                  (click)="changeUpdateTrainer(false)"
                  class="fa fa-times py-1 cross-btnn"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- for onside Session -->
      <ng-container *ngIf="sessionType == 'Onsite'">
        <div class="col-lg-12 col-md-12 col-12 mb-3">
          <label class="label-ui" for="address"
            ><i class="fa-regular fa-address-card ml-2 mr-2 result-icons"></i
            >{{ "Headquarters address" | translator }}&nbsp;:&nbsp;</label
          >
          <input
            type="text"
            id="address"
            placeholder="{{ 'Enter Address' | translator }}"
            formControlName="address"
            pInputText
            class="w-100"
          />
          <div class="error" *ngIf="isFieldError('address')">
            <div>{{ "Address Required" | translator }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-12 mb-3">
            <label class="label-ui" for="locationLink"
              ><i class="fa-solid fa-link ml-2 mr-2 result-icons"></i
              >{{ "Location Link" | translator }}&nbsp;:&nbsp;</label
            >

            <span class="pos-rel">
              <i class="fa-solid fa-map-pin result-icons pos-abs-pin"></i>
              <input
                type="text"
                id="locationLink"
                placeholder="{{ 'Enter Location Link' | translator }}"
                formControlName="locationLink"
                pInputText
                class="w-100"
              />
            </span>

            <div class="error" *ngIf="isFieldError('locationLink')">
              <div>{{ "Link required" | translator }}</div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-12 mb-3">
            <label class="label-ui" for="city">
              <i
                class="fa-solid fa-map-location-dot ml-2 mr-2 result-icons"
              ></i>
              {{ "City" | translator }}
            </label>
            <div class="pp-drop">
              <p-dropdown
                id="city"
                [filter]="true"
                filterBy="label"
                [options]="city"
                placeholder="{{ 'Choose the city' | translator }}"
                formControlName="city"
                styleClass=" sstarabic w-100"
                class="w-100"
              >
                <ng-template let-item pTemplate="item">
                  <i [ngClass]="item.icon"></i>
                  {{ item.label }}
                </ng-template>
              </p-dropdown>
            </div>
            <div class="error" *ngIf="isFieldError('City')">
              <div>{{ "city required" | translator }}</div>
            </div>
          </div>
          <div *ngIf="isHistory" class="col-lg-12 col-md-12 col-12 mb-3">
            <label class="label-ui" for="history"
              ><i class="fa-solid fa-video ml-2 mr-2 result-icons"></i
              >{{ "history" | translator }}&nbsp;:&nbsp;</label
            >
            <p-tabView>
              <p-tabPanel [header]="'Write' | translator">
                <div
                  class="d-flex flex-column align-items-start justify-content-start grey-box"
                >
                  <!-- <label class="label-ui" for="url"><i class="fa-solid fa-link ml-2 mr-2 result-icons"></i>
                  {{ "video_url" | translator }}&nbsp;:&nbsp;</label> -->
                  <input
                    type="text"
                    id="url"
                    placeholder="{{ 'video url' | translator }}"
                    formControlName="history"
                    pInputText
                    class="w-100 mb-3"
                  />
                </div>
              </p-tabPanel>
              <p-tabPanel [header]="'Upload' | translator">
                <app-file-upload
                  [label]="'Upload File' | translator"
                  (response)="materialUploadResponse($event, 'history')"
                  [imageType]="trainingMaterialImageType"
                ></app-file-upload>
              </p-tabPanel>

              <app-content-view
                *ngIf="!!sessionForm.get('history')?.value"
                [source]="getVideoUrl('history')"
                [contentType]="addedVideoContentType"
              ></app-content-view>
            </p-tabView>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionType == 'Online'">
        <div class="col-lg-12 col-md-12 col-12 mb-3">
          <label class="label-ui" for="address"
            ><i class="fa-regular fa-address-card ml-2 mr-2 result-icons"></i
            >{{ "Session Url" | translator }}&nbsp;:&nbsp;</label
          >
          <input
            type="text"
            id="address"
            placeholder="{{ 'Enter Session URL' | translator }}"
            formControlName="zoom_url"
            pInputText
            class="w-100"
          />
          <div class="error" *ngIf="isFieldError('zoom_url')">
            <div>{{ "Session Url is Required" | translator }}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionType == 'Video'">
        <div class="col-lg-12 col-md-12 col-12 mb-3">
          <div class="d-flex justify-content-between mb-2 flex-wrap">
            <label class="label-ui-2 my-2" for="video_url"
              ><i class="fa-solid fa-video ml-2 mr-2 result-icons"></i
              >{{ "video url" | translator }}&nbsp;:&nbsp;</label
            >

            <p-selectButton
              class="v4-active d-flex justify-content-end"
              [options]="blockOptions"
              formControlName="video_mode"
              optionLabel="name"
              optionValue="value"
            ></p-selectButton>
          </div>

          <p-tabView class="v4-tabview">
            <p-tabPanel [header]="'video url' | translator">
              <div
                class="d-flex flex-column align-items-start justify-content-start grey-box"
              >
                <!-- <label class="label-ui" for="url"><i class="fa-solid fa-link ml-2 mr-2 result-icons"></i>
                {{ "video_url" | translator }}&nbsp;:&nbsp;</label> -->
                <input
                  type="text"
                  id="url"
                  placeholder="{{ 'video url' | translator }}"
                  formControlName="video_url"
                  pInputText
                  class="w-100 mb-3"
                />
              </div>
            </p-tabPanel>
            <p-tabPanel [header]="'upload video' | translator">
              <app-file-upload
                [label]="'Upload File' | translator"
                (response)="materialUploadResponse($event, 'video_url')"
                [imageType]="trainingMaterialImageType"
              ></app-file-upload>
            </p-tabPanel>

            <app-content-view
              *ngIf="!!sessionForm.get('video_url')?.value"
              [source]="getVideoUrl('video_url')"
              [contentType]="addedVideoContentType"
            ></app-content-view>
          </p-tabView>

          <div class="error" *ngIf="isFieldError('video_url')">
            <div>
              {{ "Video is not uploaded and no url found" | translator }}
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="sessionType == 'Certificate'">
        <div class="col-lg-12 col-md-12 col-12 mb-3">
          <label class="label-ui" for="address"
            ><i class="fa-regular ml-2 mr-2 result-icons"></i>
            {{ "Certificate Top Text" | translator }}&nbsp;:&nbsp;</label
          >
          <textarea
            id="certTopText"
            formControlName="certTopText"
            [required]="true"
            class="w-100"
            style="
              height: 180px;
              background: rgba(34, 33, 54, 0.5);
              border: solid 1px rgba(255, 255, 255, 0.1);
              border-radius: 10px;
              color: white;
              padding: 0.5rem;
            "
          >
          </textarea>
          <div class="error" *ngIf="isFieldError('certTopText')">
            <div>{{ "Certificate Top Text is Required" | translator }}</div>
          </div>

          <label class="label-ui" for="address"
            ><i class="fa-regular ml-2 mr-2 result-icons"></i>
            {{ "Certificate Middle Text" | translator }}&nbsp;:&nbsp;</label
          >
          <textarea
            id="certMiddleText"
            formControlName="certMiddleText"
            [required]="true"
            class="w-100"
            style="
              height: 180px;
              background: rgba(34, 33, 54, 0.5);
              border: solid 1px rgba(255, 255, 255, 0.1);
              border-radius: 10px;
              color: white;
              padding: 0.5rem;
            "
          >
          </textarea>
          <div class="error" *ngIf="isFieldError('certMiddleText')">
            <div>{{ "Certificate Middle Text is Required" | translator }}</div>
          </div>

          <label class="label-ui" for="address"
            ><i class="fa-regular ml-2 mr-2 result-icons"></i>
            {{ "Certificate Bottom 1 Text" | translator }}&nbsp;:&nbsp;</label
          >
          <textarea
            id="certBottom1Text"
            formControlName="certBottom1Text"
            [required]="true"
            class="w-100"
            style="
              height: 180px;
              background: rgba(34, 33, 54, 0.5);
              border: solid 1px rgba(255, 255, 255, 0.1);
              border-radius: 10px;
              color: white;
              padding: 0.5rem;
            "
          >
          </textarea>
          <div class="error" *ngIf="isFieldError('certBottom1Text')">
            <div>
              {{ "Certificate Bottom 1 Text is Required" | translator }}
            </div>
          </div>

          <label class="label-ui" for="address"
            ><i class="fa-regular ml-2 mr-2 result-icons"></i>
            {{ "Certificate Bottom 2 Text" | translator }}&nbsp;:&nbsp;</label
          >
          <textarea
            id="certBottom2Text"
            formControlName="certBottom2Text"
            [required]="true"
            class="w-100"
            style="
              height: 180px;
              background: rgba(34, 33, 54, 0.5);
              border: solid 1px rgba(255, 255, 255, 0.1);
              border-radius: 10px;
              color: white;
              padding: 0.5rem;
            "
          >
          </textarea>
          <div class="error" *ngIf="isFieldError('certBottom2Text')">
            <div>
              {{ "Certificate Bottom 2 Text is Required" | translator }}
            </div>
          </div>

          <label class="label-ui" for="address"
            ><i class="fa-regular ml-2 mr-2 result-icons"></i>
            {{ "Certificate Bottom 3 Text" | translator }}&nbsp;:&nbsp;</label
          >
          <textarea
            id="certBottom3Text"
            formControlName="certBottom3Text"
            [required]="true"
            class="w-100"
            style="
              height: 180px;
              background: rgba(34, 33, 54, 0.5);
              border: solid 1px rgba(255, 255, 255, 0.1);
              border-radius: 10px;
              color: white;
              padding: 0.5rem;
            "
          >
          </textarea>
          <div class="error" *ngIf="isFieldError('certBottom3Text')">
            <div>
              {{ "Certificate Bottom 3 Text is Required" | translator }}
            </div>
          </div>

          <label class="label-ui" for="managerName"
            ><i class="fa-solid fa-book ml-2 mr-2 result-icons"></i>
            {{ "Manager Name" | translator }}&nbsp;:&nbsp;</label
          >
          <input
            type="text"
            id="title"
            placeholder="{{ 'Enter Manager Name' | translator }}"
            formControlName="managerName"
            pInputText
            class="w-100"
          />
          <div class="error" *ngIf="isFieldError('managerName')">
            <div>{{ "Manager Name is required" | translator }}</div>
          </div>

          <!-- Image 1 -->
          <app-file-upload
            [label]="'Upload Signature Image' | translator"
            (response)="materialUploadResponse($event, 'sign_image')"
            [imageType]="trainingMaterialImageType"
          ></app-file-upload>
          <div style="width: 200px">
            <app-content-view
              *ngIf="!!sessionForm.get('sign_image')?.value"
              [source]="getVideoUrl('sign_image')"
              [contentType]="addedImageContentType"
            ></app-content-view>
          </div>
          <div class="error" *ngIf="isFieldError('sign_image')">
            <div>
              {{ "Image is not uploaded and no url found" | translator }}
            </div>
          </div>

          <label class="label-ui" for="partnerName"
            ><i class="fa-solid fa-book ml-2 mr-2 result-icons"></i>
            {{ "Partner Name" | translator }}&nbsp;:&nbsp;</label
          >
          <input
            type="text"
            id="title"
            placeholder="{{ 'Enter Partner Name' | translator }}"
            formControlName="partnerName"
            pInputText
            class="w-100"
          />

          <!-- Image 2 -->
          <app-file-upload
            [label]="'Upload Logo Image' | translator"
            (response)="materialUploadResponse($event, 'logo_img')"
            [imageType]="trainingMaterialImageType"
          ></app-file-upload>
          <div style="width: 200px">
            <app-content-view
              *ngIf="!!sessionForm.get('logo_img')?.value"
              [source]="getVideoUrl('logo_img')"
              [contentType]="addedImageContentType"
            ></app-content-view>
          </div>
        </div>
      </ng-container>

      <div class="d-flex justify-content-center">
        <button class="v4-btn-every py-2" type="button" (click)="onSubmit()">
          {{ "Submit" | translator }}
        </button>
      </div>
    </div>
  </form>
</ng-container>

<p-dialog
  [blockScroll]="true"
  [draggable]="false"
  header="{{ 'Add Trainer' | translator }}"
  [(visible)]="addTrainerModal"
  [style]="{ margin: '0rem 1rem', width: '70vw' }"
  [maximizable]="true"
>
  <ng-container *ngIf="!showInternal; else addInternalTrainer">
    <app-add-external-user
      *ngIf="addTrainerModal"
      [addCompany]="true"
      (updatedData)="handleUpdatedUserData($event)"
      [type]="'CREATE'"
      [ExternalType]="'trainer'"
    ></app-add-external-user>
  </ng-container>
  <ng-template #addInternalTrainer>
    <app-assign-users
      [userFetchUrl]="'user/get'"
      [selectionData]="[]"
      (selectedUsersList)="assNewTrainers($event)"
      [query]="{
        'externalUser.status': { $ne: true },
        'externalUser.role': { $nin: ['trainer', 'coordinator'] }
      }"
      *ngIf="showInternal"
    >
    </app-assign-users>
  </ng-template>
</p-dialog>
